import { Pipe, PipeTransform, inject } from '@angular/core';
import { RmaUrlsService } from '../rma-urls.service';

@Pipe({
  name: 'staticImageUrl',
  standalone: true,
})
export class StaticImageUrlPipe implements PipeTransform {
  private readonly rmaUrls = inject(RmaUrlsService);

  transform(value: string): string {
    return this.rmaUrls.imageUrl(value);
  }
}
